import { createI18n } from 'vue-i18n'
import pl from './locales/pl.js'

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'pl',
  fallbackLocale: 'pl',
  messages: {
    pl
  }
})

export default i18n